var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9264 78.3133C-6.12326 47.2327 -2.52802 17.5903 26.2357 10.3198C35.0245 8.0828 46.2905 10.6393 52.5223 16.2326L55.7185 19.1087L60.4325 16.312C87.6778 -0.147 121.235 30.2145 107.013 58.4185C94.0692 84.0661 51.9632 111.631 43.3344 100.125C40.7773 96.6903 42.0555 96.2106 48.847 97.8885C55.3189 99.4863 85.2008 72.9602 92.6314 58.9782C101.58 42.1991 99.8224 33.0906 85.5204 21.5857C79.6081 16.8717 70.4196 18.9486 63.2286 26.7788C57.5559 32.8511 51.6436 33.3307 46.7696 25.6606C32.9477 4.08795 10.2557 21.1861 16.7276 48.2714C19.4442 59.4573 22.4009 65.0505 33.6663 79.9111C41.3369 89.9783 41.5759 90.4579 39.0194 91.8162C34.1453 94.4528 26.5552 89.5793 17.9264 78.3133Z",
    fill: "#D3E24B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2917 32.1332C73.3764 31.414 76.6521 27.0196 80.3273 28.2979C83.3635 29.4166 87.5984 31.2546 89.2763 35.968C91.1142 40.9215 87.4384 45.7156 85.3609 45.1565C83.5236 44.6769 82.9645 42.5994 83.204 38.365C83.4435 34.1301 81.2066 32.8518 77.2917 32.1332Z",
    fill: "#D3E24B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2402 57.4593C81.0465 58.6581 77.1317 54.7427 79.4487 52.1062C81.2066 50.1888 87.838 50.0287 89.7554 51.9467C91.3532 53.6246 90.315 56.5006 86.2402 57.4593Z",
    fill: "#D3E24B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIllustration);
export default __webpack_public_path__ + "static/media/heart-illustration.dbedb67a406a7cbc2bab034344858496.svg";
export { ForwardRef as ReactComponent };